import { IMAGES } from "./images";

// Geographic SEO silo. Each entry = a local landing page with area-specific content.
// zoneGroup drives the breadcrumb (Accueil > Zones d'intervention > {zoneLabel} > ...)
export const LOCALES = [
  // ---------------- AIN ----------------
  {
    slug: "enseigne-lumineuse-ain",
    zoneKey: "ain",
    zoneLabel: "Ain (01)",
    country: "France",
    nav: "Enseigne lumineuse Ain",
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Ain (01) | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Fabricant d'enseignes lumineuses dans l'Ain (01) : lettres boîtiers, caissons et logos LED. Étude, fabrication et pose à Saint-Jean-de-Gonville, Gex, Bourg-en-Bresse.",
    h1: "Enseigne lumineuse dans l'Ain",
    overline: "Ain • 01",
    intro: [
      "Basés à Saint-Jean-de-Gonville, au cœur du Pays de Gex, nous intervenons dans tout le département de l'Ain pour la fabrication et la pose d'enseignes lumineuses. De la devanture de commerce au totem de zone d'activité, nous accompagnons les professionnels du département de l'étude à l'installation.",
      "Notre implantation locale nous permet d'intervenir rapidement, de réaliser les relevés de façade sur place et d'assurer la maintenance de proximité.",
    ],
    localContext:
      "Le tissu économique de l'Ain mêle commerces de centre-ville (Bourg-en-Bresse, Oyonnax, Ambérieu), zones commerciales dynamiques et nombreuses PME industrielles. Nous adaptons chaque enseigne à son contexte : charme patrimonial des centres anciens, visibilité routière des zones d'activité, sobriété des parcs tertiaires.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "totem-publicitaire"],
    nearby: ["enseigniste-ain", "communication-visuelle-ain", "enseigne-lumineuse-pays-de-gex"],
    faq: [
      { q: "Intervenez-vous à Bourg-en-Bresse et dans tout l'Ain ?", a: "Oui, implantés à Saint-Jean-de-Gonville, nous couvrons l'ensemble du département de l'Ain, du Pays de Gex à Bourg-en-Bresse et à la Plastics Vallée." },
    ],
  },
  {
    slug: "enseigniste-ain",
    zoneKey: "ain",
    zoneLabel: "Ain (01)",
    country: "France",
    nav: "Enseigniste Ain",
    image: IMAGES.workshopWelding,
    title: "Enseigniste Ain (01) | Fabricant & Installateur – Ronalp Enseigne",
    metaDescription:
      "Enseigniste dans l'Ain : conception, fabrication atelier et pose d'enseignes et de signalétique. Un seul interlocuteur dans le 01, de l'étude à l'installation.",
    h1: "Votre enseigniste dans l'Ain",
    overline: "Ain • 01",
    intro: [
      "En tant qu'enseigniste implanté dans l'Ain, nous maîtrisons l'ensemble du métier : création graphique, fabrication en atelier, pose et maintenance. Vous avez un seul interlocuteur responsable de la qualité du projet, du premier croquis à l'allumage.",
      "Cette intégration garantit des délais maîtrisés, une cohérence technique et un suivi dans la durée.",
    ],
    localContext:
      "Un enseigniste local comprend les réalités du territoire : règlements de publicité des communes, contraintes des centres anciens, exigences des zones commerciales. Nous conseillons les commerçants et entreprises de l'Ain sur la solution la plus pertinente et conforme.",
    services: ["enseigne-lumineuse", "signaletique", "communication-visuelle", "lettres-relief"],
    nearby: ["enseigne-lumineuse-ain", "communication-visuelle-ain", "enseigniste-pays-de-gex"],
    faq: [
      { q: "Qu'est-ce qu'un enseigniste fait exactement ?", a: "Un enseigniste conçoit, fabrique et pose les enseignes et la signalétique. Nous couvrons tout le processus en interne, sans sous-traiter la fabrication." },
    ],
  },
  {
    slug: "communication-visuelle-ain",
    zoneKey: "ain",
    zoneLabel: "Ain (01)",
    country: "France",
    nav: "Communication visuelle Ain",
    image: IMAGES.commercial,
    title: "Communication Visuelle Ain (01) | Signalétique & Adhésifs – Ronalp",
    metaDescription:
      "Communication visuelle dans l'Ain : enseignes, signalétique, vitrophanie, marquage véhicule et impression grand format. Production et pose dans le 01.",
    h1: "Communication visuelle dans l'Ain",
    overline: "Ain • 01",
    intro: [
      "Nous accompagnons les entreprises et commerces de l'Ain sur l'ensemble de leur communication visuelle : enseignes, signalétique, vitrophanie, marquage de véhicules et impression grand format, pour une image cohérente sur tous leurs supports.",
      "De la boutique indépendante à la flotte d'utilitaires, nous produisons et posons localement.",
    ],
    localContext:
      "Les artisans et PME de l'Ain ont souvent besoin d'une image mobile forte (marquage véhicule) autant que d'une présence locale (enseigne, vitrine). Nous orchestrons ces supports pour maximiser leur visibilité sur le département.",
    services: ["communication-visuelle", "vitrophanie", "marquage-vehicule", "impression-grand-format"],
    nearby: ["enseigne-lumineuse-ain", "enseigniste-ain", "communication-visuelle-lyon"],
    faq: [
      { q: "Équipez-vous les flottes de véhicules dans l'Ain ?", a: "Oui, du marquage partiel au covering complet, nous équipons les flottes des entreprises du département." },
    ],
  },

  // ---------------- PAYS DE GEX ----------------
  {
    slug: "enseigne-lumineuse-pays-de-gex",
    zoneKey: "pays-de-gex",
    zoneLabel: "Pays de Gex",
    country: "France",
    nav: "Enseigne lumineuse Pays de Gex",
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Pays de Gex | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigniste dans le Pays de Gex : enseignes lumineuses, lettres boîtiers et caissons LED. Étude, fabrication et pose à Gex, Saint-Genis-Pouilly, Ferney-Voltaire.",
    h1: "Enseigne lumineuse dans le Pays de Gex",
    overline: "Pays de Gex",
    intro: [
      "Implantés à Saint-Jean-de-Gonville, en plein Pays de Gex, nous sommes votre partenaire de proximité pour les enseignes lumineuses. Nous connaissons parfaitement ce territoire frontalier dynamique et ses commerces tournés vers le bassin franco-genevois.",
      "Étude sur place, fabrication en atelier et pose locale : nous intervenons rapidement sur l'ensemble du Pays de Gex.",
    ],
    localContext:
      "Le Pays de Gex connaît une croissance soutenue, portée par la proximité de Genève et du CERN. Les nouveaux commerces, restaurants et enseignes de Saint-Genis-Pouilly, Ferney-Voltaire, Gex et Thoiry recherchent une visibilité forte pour capter une clientèle à fort pouvoir d'achat, souvent transfrontalière.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "enseigne-drapeau"],
    nearby: ["enseigniste-pays-de-gex", "enseigne-lumineuse-gex", "enseigne-lumineuse-saint-genis-pouilly", "enseigne-lumineuse-ferney-voltaire"],
    faq: [
      { q: "Êtes-vous situés dans le Pays de Gex ?", a: "Oui, notre atelier est à Saint-Jean-de-Gonville (01630), au cœur du Pays de Gex. Nous intervenons sur tout le territoire gessien et jusqu'à Genève." },
    ],
  },
  {
    slug: "enseigniste-pays-de-gex",
    zoneKey: "pays-de-gex",
    zoneLabel: "Pays de Gex",
    country: "France",
    nav: "Enseigniste Pays de Gex",
    image: IMAGES.craftsmanCutting,
    title: "Enseigniste Pays de Gex | Fabricant & Poseur – Ronalp Enseigne",
    metaDescription:
      "Enseigniste local dans le Pays de Gex : conception, fabrication et pose d'enseignes et signalétique à Gex, Ferney-Voltaire, Saint-Genis-Pouilly et Saint-Jean-de-Gonville.",
    h1: "Votre enseigniste dans le Pays de Gex",
    overline: "Pays de Gex",
    intro: [
      "Enseigniste établi à Saint-Jean-de-Gonville, nous fabriquons et posons nous-mêmes les enseignes des commerces et entreprises du Pays de Gex. Notre proximité est un vrai avantage : réactivité pour les relevés, les poses et la maintenance.",
      "Nous accompagnons aussi bien l'ouverture d'un nouveau commerce que le renouvellement d'une enseigne existante.",
    ],
    localContext:
      "Dans un territoire où les enseignes françaises côtoient le marché genevois, notre double culture France-Suisse est précieuse : nous conseillons sur les codes visuels attendus des deux côtés de la frontière et sur les réglementations locales françaises.",
    services: ["enseigne-lumineuse", "lettres-relief", "signaletique", "communication-visuelle"],
    nearby: ["enseigne-lumineuse-pays-de-gex", "enseigne-lumineuse-gex", "enseigniste-geneve"],
    faq: [
      { q: "Intervenez-vous aussi côté suisse ?", a: "Oui, notre position frontalière nous permet d'intervenir dans le Pays de Gex comme à Genève et dans le canton de Vaud." },
    ],
  },
  {
    slug: "enseigne-lumineuse-gex",
    zoneKey: "pays-de-gex",
    zoneLabel: "Pays de Gex",
    country: "France",
    nav: "Enseigne lumineuse Gex",
    image: IMAGES.commercial,
    title: "Enseigne Lumineuse Gex | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Gex : lettres boîtiers, caissons et enseignes LED sur mesure. Enseigniste de proximité, étude, fabrication et pose à Gex (01170).",
    h1: "Enseigne lumineuse à Gex",
    overline: "Gex",
    intro: [
      "Sous-préfecture du Pays de Gex, Gex concentre commerces de centre-ville, services et nouvelles zones d'activité. Nous y installons des enseignes lumineuses pensées pour s'intégrer au cadre montagnard et patrimonial de la commune.",
      "À quelques minutes de notre atelier de Saint-Jean-de-Gonville, nous intervenons à Gex avec une grande réactivité.",
    ],
    localContext:
      "Au pied du Jura et à proximité immédiate de la Suisse, Gex attire une clientèle résidentielle aisée et de passage. Les commerces y gagnent à soigner leur enseigne pour se démarquer dans un centre-ville en pleine valorisation.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "enseigne-drapeau", "vitrophanie"],
    nearby: ["enseigne-lumineuse-pays-de-gex", "enseigne-lumineuse-saint-genis-pouilly", "enseigne-lumineuse-ferney-voltaire"],
    faq: [
      { q: "Quel délai pour une enseigne à Gex ?", a: "Notre proximité permet un relevé rapide et une pose dans les meilleurs délais, généralement sous 2 à 4 semaines après validation." },
    ],
  },
  {
    slug: "enseigne-lumineuse-saint-genis-pouilly",
    zoneKey: "pays-de-gex",
    zoneLabel: "Pays de Gex",
    country: "France",
    nav: "Enseigne lumineuse Saint-Genis-Pouilly",
    image: IMAGES.storefront2,
    title: "Enseigne Lumineuse Saint-Genis-Pouilly | Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Saint-Genis-Pouilly : lettres LED, caissons et logos lumineux. Enseigniste de proximité pour commerces et entreprises près du CERN.",
    h1: "Enseigne lumineuse à Saint-Genis-Pouilly",
    overline: "Saint-Genis-Pouilly",
    intro: [
      "Saint-Genis-Pouilly est l'une des communes les plus dynamiques du Pays de Gex, portée par le CERN et une forte croissance résidentielle et commerciale. Nous y équipons commerces, restaurants et entreprises d'enseignes lumineuses modernes.",
      "Notre atelier voisin de Saint-Jean-de-Gonville nous permet d'intervenir sans délai sur la commune.",
    ],
    localContext:
      "Avec de nombreux programmes immobiliers et commerciaux récents, Saint-Genis-Pouilly accueille une population internationale travaillant au CERN et à Genève. Les enseignes y doivent être contemporaines, lisibles et de qualité pour séduire cette clientèle exigeante.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "communication-visuelle"],
    nearby: ["enseigne-lumineuse-pays-de-gex", "enseigne-lumineuse-ferney-voltaire", "enseigne-lumineuse-gex"],
    faq: [
      { q: "Travaillez-vous pour les commerces proches du CERN ?", a: "Oui, nous équipons régulièrement les commerces et entreprises de Saint-Genis-Pouilly et de sa zone en forte expansion." },
    ],
  },
  {
    slug: "enseigne-lumineuse-ferney-voltaire",
    zoneKey: "pays-de-gex",
    zoneLabel: "Pays de Gex",
    country: "France",
    nav: "Enseigne lumineuse Ferney-Voltaire",
    image: IMAGES.facade,
    title: "Enseigne Lumineuse Ferney-Voltaire | Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Ferney-Voltaire : lettres LED, caissons et enseignes sur mesure. Enseigniste de proximité aux portes de Genève.",
    h1: "Enseigne lumineuse à Ferney-Voltaire",
    overline: "Ferney-Voltaire",
    intro: [
      "Aux portes de Genève et de son aéroport, Ferney-Voltaire est une ville commerçante au cadre historique soigné. Nous y réalisons des enseignes lumineuses qui respectent le caractère patrimonial de la cité de Voltaire tout en offrant une visibilité moderne.",
      "Proximité oblige, nous intervenons rapidement sur Ferney-Voltaire depuis notre atelier de Saint-Jean-de-Gonville.",
    ],
    localContext:
      "Le centre historique et les projets d'aménagement (secteur Ferney-Genève Innovation) font de Ferney-Voltaire une commune à forte attractivité, très proche de Genève. Les enseignes doivent conjuguer élégance patrimoniale et modernité.",
    services: ["enseigne-lumineuse", "lettres-relief", "enseigne-drapeau", "vitrophanie"],
    nearby: ["enseigne-lumineuse-pays-de-gex", "enseigne-lumineuse-saint-genis-pouilly", "enseigne-lumineuse-geneve"],
    faq: [
      { q: "Les enseignes sont-elles adaptées au centre historique ?", a: "Oui, nous concevons des enseignes respectueuses du patrimoine, en accord avec les prescriptions locales." },
    ],
  },

  // ---------------- HAUTE-SAVOIE ----------------
  {
    slug: "enseigne-lumineuse-haute-savoie",
    zoneKey: "haute-savoie",
    zoneLabel: "Haute-Savoie (74)",
    country: "France",
    nav: "Enseigne lumineuse Haute-Savoie",
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Haute-Savoie (74) | Fabrication & Pose",
    metaDescription:
      "Fabricant et installateur d'enseignes lumineuses en Haute-Savoie : lettres boîtiers, caissons et logos LED. Pose à Annecy, Annemasse, Saint-Julien-en-Genevois.",
    h1: "Fabricant et installateur d'enseignes lumineuses en Haute-Savoie",
    overline: "Haute-Savoie • 74",
    intro: [
      "Nous intervenons dans toute la Haute-Savoie pour la conception, la fabrication et la pose d'enseignes lumineuses. Du bassin annécien à la frontière genevoise, nous équipons commerces, hôtels, restaurants et entreprises.",
      "Fabrication en atelier et pose par nos équipes : un accompagnement complet pour des enseignes durables.",
    ],
    localContext:
      "La Haute-Savoie allie tourisme, dynamisme frontalier et qualité de vie. Les enseignes y doivent valoriser des établissements variés : hôtels et restaurants touristiques autour d'Annecy et du lac, commerces frontaliers à Annemasse et Saint-Julien, PME des zones d'activité. Nous adaptons matériaux et éclairage à chaque contexte, y compris en altitude.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "enseigne-drapeau"],
    nearby: ["enseigniste-haute-savoie", "enseigne-lumineuse-annemasse", "enseigne-lumineuse-annecy", "enseigne-lumineuse-saint-julien-en-genevois"],
    faq: [
      { q: "Couvrez-vous tout le département de la Haute-Savoie ?", a: "Oui, d'Annecy à la frontière suisse, nous intervenons sur l'ensemble de la Haute-Savoie." },
    ],
  },
  {
    slug: "enseigniste-haute-savoie",
    zoneKey: "haute-savoie",
    zoneLabel: "Haute-Savoie (74)",
    country: "France",
    nav: "Enseigniste Haute-Savoie",
    image: IMAGES.workshopWelding,
    title: "Enseigniste Haute-Savoie (74) | Fabricant & Poseur – Ronalp",
    metaDescription:
      "Enseigniste en Haute-Savoie : conception, fabrication et pose d'enseignes et de signalétique. Un seul interlocuteur dans le 74, de l'étude à l'installation.",
    h1: "Votre enseigniste en Haute-Savoie",
    overline: "Haute-Savoie • 74",
    intro: [
      "Enseigniste intervenant dans le 74, nous prenons en charge l'intégralité de votre projet : création, fabrication atelier, pose et maintenance. Vous bénéficiez d'un interlocuteur unique et d'une qualité maîtrisée de bout en bout.",
      "Nous intervenons des rives du lac d'Annecy jusqu'au bassin genevois.",
    ],
    localContext:
      "Les professionnels haut-savoyards attendent des enseignes qui reflètent l'exigence du territoire : stations, hôtellerie de qualité, commerces frontaliers. Notre savoir-faire d'enseigniste fabricant garantit des réalisations à la hauteur de ces standards.",
    services: ["enseigne-lumineuse", "signaletique", "communication-visuelle", "lettres-relief"],
    nearby: ["enseigne-lumineuse-haute-savoie", "enseigne-lumineuse-annecy", "enseigniste-geneve"],
    faq: [
      { q: "Faites-vous aussi la maintenance en Haute-Savoie ?", a: "Oui, en tant qu'enseigniste local nous assurons l'entretien et le dépannage de vos enseignes dans le département." },
    ],
  },
  {
    slug: "enseigne-lumineuse-annemasse",
    zoneKey: "haute-savoie",
    zoneLabel: "Haute-Savoie (74)",
    country: "France",
    nav: "Enseigne lumineuse Annemasse",
    image: IMAGES.commercial,
    title: "Enseigne Lumineuse Annemasse | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Annemasse : lettres LED, caissons et enseignes sur mesure. Enseigniste pour commerces et entreprises de l'agglomération annemassienne.",
    h1: "Enseigne lumineuse à Annemasse",
    overline: "Annemasse",
    intro: [
      "Première agglomération de Haute-Savoie après Annecy, Annemasse est un pôle commercial majeur du Grand Genève. Nous y installons des enseignes lumineuses pour une clientèle dense et transfrontalière.",
      "Commerces de centre-ville, zones commerciales et restaurants : nous équipons tous les formats d'établissement.",
    ],
    localContext:
      "Intégrée au Grand Genève et desservie par le Léman Express, Annemasse connaît un fort développement urbain et commercial. La concurrence y est vive : une enseigne lumineuse de qualité fait la différence pour capter les flux franco-suisses.",
    services: ["enseigne-lumineuse", "caisson-lumineux", "lettres-boitiers", "communication-visuelle"],
    nearby: ["enseigne-lumineuse-haute-savoie", "enseigne-lumineuse-saint-julien-en-genevois", "enseigne-lumineuse-geneve"],
    faq: [
      { q: "Travaillez-vous pour les commerces du Grand Genève côté Annemasse ?", a: "Oui, nous équipons régulièrement les établissements d'Annemasse et de son agglomération transfrontalière." },
    ],
  },
  {
    slug: "enseigne-lumineuse-saint-julien-en-genevois",
    zoneKey: "haute-savoie",
    zoneLabel: "Haute-Savoie (74)",
    country: "France",
    nav: "Enseigne lumineuse Saint-Julien-en-Genevois",
    image: IMAGES.storefront2,
    title: "Enseigne Lumineuse Saint-Julien-en-Genevois | Pose – Ronalp",
    metaDescription:
      "Enseigne lumineuse à Saint-Julien-en-Genevois : lettres LED, caissons et logos lumineux. Enseigniste de proximité à la frontière genevoise.",
    h1: "Enseigne lumineuse à Saint-Julien-en-Genevois",
    overline: "Saint-Julien-en-Genevois",
    intro: [
      "Porte d'entrée de la France depuis Genève, Saint-Julien-en-Genevois est une ville commerçante en pleine croissance. Nous y réalisons des enseignes lumineuses pour commerces, zones commerciales et entreprises.",
      "Sa position frontalière en fait un emplacement stratégique où la visibilité de l'enseigne est déterminante.",
    ],
    localContext:
      "Traversée par d'importants flux transfrontaliers, Saint-Julien-en-Genevois accueille de grandes zones commerciales fréquentées par la clientèle genevoise. Une enseigne lumineuse puissante et bien conçue y maximise l'attractivité.",
    services: ["enseigne-lumineuse", "caisson-lumineux", "totem-publicitaire", "communication-visuelle"],
    nearby: ["enseigne-lumineuse-haute-savoie", "enseigne-lumineuse-annemasse", "enseigne-lumineuse-geneve"],
    faq: [
      { q: "Réalisez-vous des totems pour les zones commerciales ?", a: "Oui, nous concevons et posons des totems lumineux adaptés aux zones commerciales de Saint-Julien et de sa région." },
    ],
  },
  {
    slug: "enseigne-lumineuse-annecy",
    zoneKey: "haute-savoie",
    zoneLabel: "Haute-Savoie (74)",
    country: "France",
    nav: "Enseigne lumineuse Annecy",
    image: IMAGES.facade,
    title: "Enseigne Lumineuse Annecy | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Annecy : lettres boîtiers, lettres relief et enseignes LED. Enseigniste pour commerces, hôtels et restaurants du bassin annécien.",
    h1: "Enseigne lumineuse à Annecy",
    overline: "Annecy",
    intro: [
      "Capitale de la Haute-Savoie, Annecy conjugue tourisme, commerce et cadre patrimonial exceptionnel. Nous y réalisons des enseignes lumineuses élégantes, respectueuses de la vieille ville et performantes dans les zones commerciales périphériques.",
      "Hôtels, restaurants, boutiques : nous adaptons chaque enseigne au caractère de la ville.",
    ],
    localContext:
      "Entre lac et vieille ville classée, Annecy impose une grande exigence esthétique, notamment en secteur sauvegardé où les enseignes sont encadrées. Nous concevons des solutions discrètes et qualitatives pour le centre, plus affirmées pour les zones commerciales comme Seynod ou Épagny.",
    services: ["enseigne-lumineuse", "lettres-relief", "lettres-boitiers", "enseigne-drapeau"],
    nearby: ["enseigne-lumineuse-haute-savoie", "enseigniste-haute-savoie", "enseigne-lumineuse-annemasse"],
    faq: [
      { q: "Les enseignes sont-elles adaptées à la vieille ville d'Annecy ?", a: "Oui, nous concevons des enseignes conformes aux prescriptions du secteur sauvegardé, élégantes et discrètes." },
    ],
  },

  // ---------------- LYON ----------------
  {
    slug: "enseigne-lumineuse-lyon",
    zoneKey: "lyon",
    zoneLabel: "Lyon & Rhône",
    country: "France",
    nav: "Enseigne lumineuse Lyon",
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Lyon | Fabrication, Installation & Signalétique",
    metaDescription:
      "Enseigne lumineuse à Lyon et dans le Rhône : lettres boîtiers, caissons et logos LED. Fabrication, installation et signalétique pour commerces et entreprises.",
    h1: "Enseignes lumineuses et communication visuelle à Lyon",
    overline: "Lyon • Rhône • Auvergne-Rhône-Alpes",
    intro: [
      "Métropole majeure d'Auvergne-Rhône-Alpes, Lyon offre un terrain commercial dense et exigeant. Nous y réalisons enseignes lumineuses, signalétique et communication visuelle pour commerces, entreprises et établissements.",
      "De la Presqu'île aux zones tertiaires de Part-Dieu, Gerland ou Vaise, nous adaptons chaque projet au tissu urbain lyonnais.",
    ],
    localContext:
      "Lyon combine un patrimoine protégé (Presqu'île, Vieux Lyon classé UNESCO), de grands quartiers d'affaires et des zones commerciales périphériques très concurrentielles. Les enseignes doivent répondre à des règlements de publicité stricts en centre-ville tout en offrant une visibilité forte ailleurs.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "signaletique", "communication-visuelle"],
    nearby: ["enseigniste-lyon", "communication-visuelle-lyon", "enseigne-lumineuse-ain"],
    faq: [
      { q: "Intervenez-vous dans toute la métropole de Lyon ?", a: "Oui, nous couvrons Lyon et sa métropole, ainsi que le département du Rhône et la région Auvergne-Rhône-Alpes." },
    ],
  },
  {
    slug: "enseigniste-lyon",
    zoneKey: "lyon",
    zoneLabel: "Lyon & Rhône",
    country: "France",
    nav: "Enseigniste Lyon",
    image: IMAGES.workshopWelding,
    title: "Enseigniste Lyon | Fabricant & Installateur – Ronalp Enseigne",
    metaDescription:
      "Enseigniste à Lyon : conception, fabrication et pose d'enseignes et de signalétique pour commerces et entreprises de la métropole lyonnaise.",
    h1: "Votre enseigniste à Lyon",
    overline: "Lyon • Rhône",
    intro: [
      "Enseigniste intervenant sur la métropole lyonnaise, nous maîtrisons la fabrication et la pose d'enseignes et de signalétique. Un interlocuteur unique pour un projet cohérent, de la création à l'installation.",
      "Nous accompagnons aussi bien les commerces indépendants que les réseaux et entreprises du Grand Lyon.",
    ],
    localContext:
      "Le marché lyonnais exige des prestataires capables de gérer des projets multiples (réseaux de franchises, immeubles tertiaires) et de maîtriser les règlements locaux de publicité. Notre intégration fabrication-pose garantit homogénéité et respect des délais.",
    services: ["enseigne-lumineuse", "signaletique", "communication-visuelle", "lettres-relief"],
    nearby: ["enseigne-lumineuse-lyon", "communication-visuelle-lyon", "enseigniste-ain"],
    faq: [
      { q: "Gérez-vous des déploiements multi-sites à Lyon ?", a: "Oui, nous réalisons des programmes homogènes pour réseaux et enseignes à plusieurs implantations." },
    ],
  },
  {
    slug: "communication-visuelle-lyon",
    zoneKey: "lyon",
    zoneLabel: "Lyon & Rhône",
    country: "France",
    nav: "Communication visuelle Lyon",
    image: IMAGES.commercial,
    title: "Communication Visuelle Lyon | Signalétique & Adhésifs – Ronalp",
    metaDescription:
      "Communication visuelle à Lyon : enseignes, signalétique, vitrophanie, marquage véhicule et impression grand format. Production et pose dans la métropole lyonnaise.",
    h1: "Communication visuelle à Lyon",
    overline: "Lyon • Rhône",
    intro: [
      "Nous accompagnons les entreprises et commerces lyonnais sur l'ensemble de leur communication visuelle : enseignes, signalétique, vitrophanie, marquage de véhicules et impression grand format.",
      "Une image cohérente sur tous les supports, du point de vente à la flotte.",
    ],
    localContext:
      "Dans une métropole aussi concurrentielle que Lyon, la cohérence de l'image de marque sur tous les supports est un atout décisif. Nous orchestrons enseigne, vitrine, véhicules et PLV pour une présence forte et homogène.",
    services: ["communication-visuelle", "vitrophanie", "marquage-vehicule", "impression-grand-format"],
    nearby: ["enseigne-lumineuse-lyon", "enseigniste-lyon", "communication-visuelle-ain"],
    faq: [
      { q: "Pouvez-vous gérer la communication visuelle d'un réseau à Lyon ?", a: "Oui, nous déployons des chartes visuelles homogènes sur plusieurs points de vente de la métropole." },
    ],
  },

  // ---------------- GENÈVE ----------------
  {
    slug: "enseigne-lumineuse-geneve",
    zoneKey: "geneve",
    zoneLabel: "Genève",
    country: "Suisse",
    nav: "Enseigne lumineuse Genève",
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Genève | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseignes lumineuses sur mesure à Genève : lettres boîtiers, logos LED, signalétique et communication visuelle. Étude, fabrication et installation.",
    h1: "Enseignes lumineuses sur mesure à Genève",
    overline: "Genève • Suisse",
    intro: [
      "Genève est un marché premium où l'image de marque est reine. Nous y concevons, fabriquons et installons des enseignes lumineuses haut de gamme pour commerces, hôtels, restaurants, pharmacies, bureaux et boutiques.",
      "Depuis notre atelier tout proche du Pays de Gex, nous intervenons à Genève avec réactivité et une parfaite connaissance des deux côtés de la frontière.",
    ],
    localContext:
      "Place financière internationale, Genève abrite horlogers, banques privées, boutiques de luxe, hôtellerie haut de gamme et nombreuses pharmacies. Les enseignes y doivent incarner un niveau d'exigence élevé : matériaux nobles, finitions irréprochables, éclairage maîtrisé et discrétion élégante, souvent dans des immeubles au cachet patrimonial fort (Rue du Rhône, vieille ville, Plainpalais, Eaux-Vives).",
    services: ["enseigne-lumineuse", "lettres-boitiers", "lettres-lumineuses", "caisson-lumineux"],
    nearby: ["enseigniste-geneve", "communication-visuelle-geneve", "signaletique-geneve", "lettres-lumineuses-geneve"],
    faq: [
      { q: "Intervenez-vous à Genève depuis la France ?", a: "Oui, notre atelier du Pays de Gex est à quelques minutes de Genève. Nous y réalisons études, fabrication et pose régulièrement." },
      { q: "Proposez-vous des enseignes adaptées au luxe genevois ?", a: "Oui, nous travaillons des matériaux nobles (inox, laiton, plexiglas premium) et des finitions soignées pour les enseignes haut de gamme." },
    ],
  },
  {
    slug: "enseigniste-geneve",
    zoneKey: "geneve",
    zoneLabel: "Genève",
    country: "Suisse",
    nav: "Enseigniste Genève",
    image: IMAGES.craftsmanCutting,
    title: "Enseigniste Genève | Fabricant & Installateur – Ronalp Enseigne",
    metaDescription:
      "Enseigniste à Genève : conception, fabrication et pose d'enseignes lumineuses et de signalétique. Un interlocuteur unique pour commerces et entreprises genevois.",
    h1: "Votre enseigniste à Genève",
    overline: "Genève • Suisse",
    intro: [
      "Enseigniste fabricant intervenant à Genève, nous maîtrisons l'ensemble du processus : étude, fabrication en atelier, pose et maintenance. Notre proximité frontalière assure réactivité et suivi dans la durée.",
      "Nous accompagnons les commerces, boutiques, restaurants et entreprises du canton.",
    ],
    localContext:
      "À Genève, un enseigniste doit conjuguer exigence esthétique, qualité d'exécution et compréhension des contraintes d'immeubles souvent protégés. Notre double ancrage France-Suisse nous permet de proposer un excellent rapport qualité-prix tout en respectant les standards genevois.",
    services: ["enseigne-lumineuse", "signaletique", "lettres-relief", "communication-visuelle"],
    nearby: ["enseigne-lumineuse-geneve", "communication-visuelle-geneve", "signaletique-geneve"],
    faq: [
      { q: "Assurez-vous la maintenance des enseignes à Genève ?", a: "Oui, nous intervenons pour l'entretien et le dépannage des enseignes sur le canton de Genève." },
    ],
  },
  {
    slug: "communication-visuelle-geneve",
    zoneKey: "geneve",
    zoneLabel: "Genève",
    country: "Suisse",
    nav: "Communication visuelle Genève",
    image: IMAGES.storefront2,
    title: "Communication Visuelle Genève | Signalétique & Adhésifs – Ronalp",
    metaDescription:
      "Communication visuelle à Genève : enseignes, signalétique, vitrophanie, marquage véhicule et impression grand format. Production et pose pour le canton de Genève.",
    h1: "Communication visuelle à Genève",
    overline: "Genève • Suisse",
    intro: [
      "Nous accompagnons les commerces et entreprises genevois sur toute leur communication visuelle : enseignes, signalétique, vitrophanie, marquage de véhicules et impression grand format, avec le niveau de finition attendu à Genève.",
      "Une image cohérente et premium, de la vitrine au véhicule.",
    ],
    localContext:
      "Le marché genevois valorise fortement la cohérence et la qualité de l'image de marque. Boutiques de luxe, institutions et PME y attendent des supports haut de gamme et parfaitement exécutés. Nous orchestrons l'ensemble de ces supports.",
    services: ["communication-visuelle", "vitrophanie", "marquage-vehicule", "impression-grand-format"],
    nearby: ["enseigne-lumineuse-geneve", "enseigniste-geneve", "signaletique-geneve"],
    faq: [
      { q: "Réalisez-vous la vitrophanie des boutiques genevoises ?", a: "Oui, de la découpe élégante à l'impression haute définition, nous habillons les vitrines à Genève." },
    ],
  },
  {
    slug: "signaletique-geneve",
    zoneKey: "geneve",
    zoneLabel: "Genève",
    country: "Suisse",
    nav: "Signalétique Genève",
    image: IMAGES.commercial,
    title: "Signalétique Genève | Intérieure & Extérieure – Ronalp Enseigne",
    metaDescription:
      "Signalétique professionnelle à Genève : plaques, totems, signalétique directionnelle intérieure et extérieure. Conception et pose pour entreprises genevoises.",
    h1: "Signalétique professionnelle à Genève",
    overline: "Genève • Suisse",
    intro: [
      "À Genève, la signalétique accompagne l'image d'excellence des entreprises, institutions et commerces. Nous concevons des systèmes cohérents, élégants et durables, en intérieur comme en extérieur.",
      "Plaques, totems d'accueil, fléchage directionnel : nous structurons l'expérience de vos visiteurs.",
    ],
    localContext:
      "Sièges internationaux, banques privées, cliniques et hôtels de standing : les lieux genevois exigent une signalétique sobre et raffinée, souvent multilingue. Nous intégrons ces besoins avec des matériaux nobles et une exécution soignée.",
    services: ["signaletique", "signaletique-interieure", "signaletique-exterieure", "lettres-relief"],
    nearby: ["enseigne-lumineuse-geneve", "enseigniste-geneve", "communication-visuelle-geneve"],
    faq: [
      { q: "Proposez-vous une signalétique multilingue à Genève ?", a: "Oui, nous réalisons une signalétique adaptée au contexte international genevois, en plusieurs langues si nécessaire." },
    ],
  },
  {
    slug: "lettres-lumineuses-geneve",
    zoneKey: "geneve",
    zoneLabel: "Genève",
    country: "Suisse",
    nav: "Lettres lumineuses Genève",
    image: IMAGES.neonWorkshop,
    title: "Lettres Lumineuses Genève | Boîtiers & Relief LED – Ronalp",
    metaDescription:
      "Lettres lumineuses LED à Genève : lettres boîtiers et lettres relief sur mesure pour façades premium. Fabrication et pose par un enseigniste fabricant.",
    h1: "Lettres lumineuses à Genève",
    overline: "Genève • Suisse",
    intro: [
      "Les lettres lumineuses sont la signature des façades genevoises haut de gamme. Nous fabriquons lettres boîtiers et lettres relief sur mesure, avec un éclairage LED maîtrisé et des finitions premium.",
      "Un rendu élégant et durable, à la hauteur des adresses les plus exigeantes de Genève.",
    ],
    localContext:
      "Sur la Rue du Rhône, aux Eaux-Vives ou en vieille ville, les enseignes en lettres découpées incarnent le raffinement genevois. Nous travaillons l'inox, le laiton et le plexiglas premium pour des lettres lumineuses dignes de ce marché.",
    services: ["lettres-lumineuses", "lettres-boitiers", "lettres-relief", "enseigne-lumineuse"],
    nearby: ["enseigne-lumineuse-geneve", "enseigniste-geneve", "signaletique-geneve"],
    faq: [
      { q: "Travaillez-vous le laiton et l'inox pour Genève ?", a: "Oui, nous proposons des lettres en matériaux nobles (inox, laiton) pour les enseignes premium genevoises." },
    ],
  },

  // ---------------- VAUD ----------------
  {
    slug: "enseigne-lumineuse-vaud",
    zoneKey: "vaud",
    zoneLabel: "Vaud",
    country: "Suisse",
    nav: "Enseigne lumineuse Vaud",
    image: IMAGES.storefrontNight,
    title: "Enseigne Lumineuse Vaud | Fabrication & Installation – Ronalp",
    metaDescription:
      "Enseignes lumineuses dans le canton de Vaud : lettres boîtiers, caissons et logos LED. Fabrication et pose à Lausanne, Nyon, Morges et toute la région.",
    h1: "Enseignes lumineuses dans le canton de Vaud",
    overline: "Vaud • Suisse",
    intro: [
      "Le canton de Vaud, de Nyon à Lausanne le long du lac Léman, offre un marché commercial dynamique et qualitatif. Nous y réalisons des enseignes lumineuses sur mesure pour commerces, entreprises et établissements.",
      "Étude, fabrication en atelier et pose : un accompagnement complet dans toute la région lémanique vaudoise.",
    ],
    localContext:
      "Vaud combine la métropole lausannoise, le dynamisme économique de la Côte (Nyon, Morges) et un important secteur viticole et touristique sur les rives du Léman. Les enseignes y doivent allier qualité suisse, lisibilité et respect d'un cadre souvent patrimonial et paysager remarquable.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "communication-visuelle"],
    nearby: ["enseigniste-vaud", "enseigne-lumineuse-lausanne", "enseigne-lumineuse-nyon", "signaletique-lausanne"],
    faq: [
      { q: "Couvrez-vous tout le canton de Vaud ?", a: "Oui, de Nyon à Lausanne et au-delà, nous intervenons dans l'ensemble du canton de Vaud." },
    ],
  },
  {
    slug: "enseigniste-vaud",
    zoneKey: "vaud",
    zoneLabel: "Vaud",
    country: "Suisse",
    nav: "Enseigniste Vaud",
    image: IMAGES.workshopWelding,
    title: "Enseigniste Vaud | Fabricant & Installateur – Ronalp Enseigne",
    metaDescription:
      "Enseigniste dans le canton de Vaud : conception, fabrication et pose d'enseignes et de signalétique à Lausanne, Nyon et dans toute la région lémanique.",
    h1: "Votre enseigniste dans le canton de Vaud",
    overline: "Vaud • Suisse",
    intro: [
      "Enseigniste fabricant intervenant dans le canton de Vaud, nous prenons en charge l'ensemble du projet : création, fabrication, pose et maintenance. Un interlocuteur unique pour une qualité constante.",
      "Nous accompagnons commerces et entreprises de Nyon à Lausanne.",
    ],
    localContext:
      "Le marché vaudois attend des enseignes conformes aux standards suisses de qualité et de durabilité. Notre savoir-faire d'enseigniste fabricant, combiné à notre proximité frontalière, offre réactivité et excellent rapport qualité-prix.",
    services: ["enseigne-lumineuse", "signaletique", "communication-visuelle", "lettres-relief"],
    nearby: ["enseigne-lumineuse-vaud", "enseigne-lumineuse-lausanne", "enseigne-lumineuse-nyon"],
    faq: [
      { q: "Intervenez-vous à Nyon et Lausanne ?", a: "Oui, nous couvrons la Côte (Nyon, Morges) et l'agglomération lausannoise, ainsi que le reste du canton." },
    ],
  },
  {
    slug: "communication-visuelle-vaud",
    zoneKey: "vaud",
    zoneLabel: "Vaud",
    country: "Suisse",
    nav: "Communication visuelle Vaud",
    image: IMAGES.commercial,
    title: "Communication Visuelle Vaud | Signalétique & Adhésifs – Ronalp",
    metaDescription:
      "Communication visuelle dans le canton de Vaud : enseignes, signalétique, vitrophanie, marquage véhicule et grand format. Production et pose à Lausanne et Nyon.",
    h1: "Communication visuelle dans le canton de Vaud",
    overline: "Vaud • Suisse",
    intro: [
      "Nous accompagnons les entreprises et commerces vaudois sur l'ensemble de leur communication visuelle : enseignes, signalétique, vitrophanie, marquage de véhicules et impression grand format.",
      "Une image cohérente et qualitative, de la vitrine à la flotte, dans toute la région lémanique.",
    ],
    localContext:
      "Entre Lausanne, pôle économique et universitaire, et la Côte dynamique, les entreprises vaudoises recherchent une communication visuelle soignée et homogène. Nous orchestrons tous les supports pour une présence forte sur le canton.",
    services: ["communication-visuelle", "vitrophanie", "marquage-vehicule", "impression-grand-format"],
    nearby: ["enseigne-lumineuse-vaud", "enseigniste-vaud", "signaletique-lausanne"],
    faq: [
      { q: "Équipez-vous les véhicules d'entreprise dans le canton de Vaud ?", a: "Oui, du marquage partiel au covering complet, nous équipons les flottes vaudoises." },
    ],
  },
  {
    slug: "enseigne-lumineuse-nyon",
    zoneKey: "vaud",
    zoneLabel: "Vaud",
    country: "Suisse",
    nav: "Enseigne lumineuse Nyon",
    image: IMAGES.storefront2,
    title: "Enseigne Lumineuse Nyon | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Nyon : lettres LED, caissons et logos lumineux sur mesure. Enseigniste de proximité pour commerces et entreprises de la Côte vaudoise.",
    h1: "Enseigne lumineuse à Nyon",
    overline: "Nyon • Vaud",
    intro: [
      "Entre Genève et Lausanne, Nyon est une ville commerçante prospère de la Côte vaudoise. Nous y installons des enseignes lumineuses pour commerces de centre-ville, zones d'activité et entreprises.",
      "Proche de la frontière, Nyon est aisément accessible depuis notre atelier pour des interventions réactives.",
    ],
    localContext:
      "Ville au bord du Léman au riche patrimoine (château, vieille ville), Nyon accueille de nombreux sièges d'entreprises et une clientèle aisée. Les enseignes y doivent conjuguer qualité suisse et respect du cadre historique.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "enseigne-drapeau", "vitrophanie"],
    nearby: ["enseigne-lumineuse-vaud", "enseigne-lumineuse-lausanne", "enseigne-lumineuse-geneve"],
    faq: [
      { q: "Intervenez-vous facilement à Nyon depuis la France ?", a: "Oui, Nyon est à proximité immédiate de la frontière, ce qui nous permet d'intervenir rapidement." },
    ],
  },
  {
    slug: "enseigne-lumineuse-lausanne",
    zoneKey: "vaud",
    zoneLabel: "Vaud",
    country: "Suisse",
    nav: "Enseigne lumineuse Lausanne",
    image: IMAGES.facade,
    title: "Enseigne Lumineuse Lausanne | Fabrication & Pose – Ronalp Enseigne",
    metaDescription:
      "Enseigne lumineuse à Lausanne : lettres boîtiers, caissons et logos LED sur mesure. Enseigniste pour commerces, hôtels et entreprises de la capitale vaudoise.",
    h1: "Enseigne lumineuse à Lausanne",
    overline: "Lausanne • Vaud",
    intro: [
      "Capitale du canton de Vaud et ville olympique, Lausanne est un pôle commercial, universitaire et touristique majeur. Nous y réalisons des enseignes lumineuses pour commerces, hôtels, restaurants et entreprises.",
      "Du centre à Flon et aux quartiers d'affaires, nous adaptons chaque enseigne à son environnement.",
    ],
    localContext:
      "Lausanne mêle centre historique en pente, quartier branché du Flon, pôles universitaires (EPFL, UNIL) et sièges d'entreprises. Les enseignes doivent composer avec un relief marqué et des exigences esthétiques élevées, au cœur d'une agglomération dense.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "caisson-lumineux", "signaletique"],
    nearby: ["enseigne-lumineuse-vaud", "enseigniste-vaud", "signaletique-lausanne"],
    faq: [
      { q: "Travaillez-vous pour l'hôtellerie et la restauration à Lausanne ?", a: "Oui, nous équipons hôtels, restaurants et commerces lausannois d'enseignes lumineuses sur mesure." },
    ],
  },
  {
    slug: "signaletique-lausanne",
    zoneKey: "vaud",
    zoneLabel: "Vaud",
    country: "Suisse",
    nav: "Signalétique Lausanne",
    image: IMAGES.commercial,
    title: "Signalétique Lausanne | Intérieure & Extérieure – Ronalp Enseigne",
    metaDescription:
      "Signalétique professionnelle à Lausanne : plaques, totems et signalétique directionnelle pour entreprises, campus et établissements. Conception et pose.",
    h1: "Signalétique professionnelle à Lausanne",
    overline: "Lausanne • Vaud",
    intro: [
      "À Lausanne, la signalétique structure l'expérience des visiteurs dans des environnements variés : sièges d'entreprises, campus, établissements de santé et commerces. Nous concevons des systèmes cohérents, lisibles et durables.",
      "Signalétique intérieure et extérieure, de la plaque au totem directionnel.",
    ],
    localContext:
      "Avec ses campus (EPFL, UNIL), ses sièges internationaux et son agglomération au relief marqué, Lausanne exige une signalétique claire et élégante, souvent sur de grands ensembles. Nous répondons à ces besoins de guidage et d'image.",
    services: ["signaletique", "signaletique-interieure", "signaletique-exterieure", "lettres-relief"],
    nearby: ["enseigne-lumineuse-lausanne", "enseigniste-vaud", "communication-visuelle-vaud"],
    faq: [
      { q: "Réalisez-vous la signalétique de grands sites à Lausanne ?", a: "Oui, nous concevons des programmes de signalétique complets pour campus, sièges et établissements." },
    ],
  },
];

export const LOCALES_BY_SLUG = Object.fromEntries(LOCALES.map((l) => [l.slug, l]));
export const getLocale = (slug) => LOCALES_BY_SLUG[slug];

export const ZONES = [
  { key: "ain", label: "Ain (01)", country: "France", hub: "enseigne-lumineuse-ain" },
  { key: "pays-de-gex", label: "Pays de Gex", country: "France", hub: "enseigne-lumineuse-pays-de-gex" },
  { key: "haute-savoie", label: "Haute-Savoie (74)", country: "France", hub: "enseigne-lumineuse-haute-savoie" },
  { key: "lyon", label: "Lyon & Auvergne-Rhône-Alpes", country: "France", hub: "enseigne-lumineuse-lyon" },
  { key: "geneve", label: "Genève", country: "Suisse", hub: "enseigne-lumineuse-geneve" },
  { key: "vaud", label: "Canton de Vaud", country: "Suisse", hub: "enseigne-lumineuse-vaud" },
];
